import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import {
  SkBadgeComponent,
  SkButtonComponent,
  SkIconComponent,
} from '@mercadoni/stark-ui';

import { FavoritesService, HalloweenService } from '../../core/services';
import { NfClusterSelectorComponent } from '../../shared/components/nf-cluster-selector/nf-cluster-selector.component';

@Component({
  selector: 'nf-topbar',
  imports: [TranslocoPipe, SkButtonComponent, SkIconComponent, SkBadgeComponent, NfClusterSelectorComponent],
  templateUrl: './topbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NfTopbarComponent {
  private readonly favorites = inject(FavoritesService);
  protected readonly halloween = inject(HalloweenService);

  readonly featureName  = input<string>('Process Records');
  readonly featureIcon  = input<string>('activity');
  readonly featureId    = input<string>('');
  readonly unreadCount  = input<number>(0);
  readonly isDarkMode   = input<boolean>(false);

  readonly openNotifs  = output<void>();
  readonly openSearch  = output<void>();
  readonly toggleTheme = output<void>();

  readonly isFavorite = computed(() => this.favorites.isFavorite(this.featureId()));

  toggleFavorite(): void {
    this.favorites.toggleFavorite(this.featureId());
  }
}
